/**
 * ISO 3166-1 alpha-2 → English country name, zero-dependency via
 * `Intl.DisplayNames`. Accepts either case (CrUX returns lower-case
 * 'us'); falls back to the upper-cased code when the runtime lacks
 * DisplayNames or the code is unknown.
 */
const REGION_NAMES =
  typeof Intl !== 'undefined' && 'DisplayNames' in Intl
    ? new Intl.DisplayNames(['en'], { type: 'region' })
    : null;

export function countryName(code: string): string {
  const upper = code.toUpperCase();
  return REGION_NAMES?.of(upper) ?? upper;
}
